import { SvgIcon } from '@mui/material';

export function SplitGeometry() {
  return (
    <SvgIcon>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path d="M24 6v13H14v-1h9V7h-9V6zM11 18H2V7h9V6H1v13h10zm2 3h1v3h-3v-3h1V4h-1V1h3v3h-1zM12 3h1V2h-1zm1 19h-1v1h1z" />
        <path fill="none" d="M0 0h24v24H0z" />
      </svg>
    </SvgIcon>
  );
}
